import React from 'react'

import T from 'utils/useLocalizer';
import OrderSettingsForm from 'components/features/orders/form/OrderSettingsForm';
import PageHeader from 'components/features/orders/orderSettings/PageHeader';
import HorizontalDivider from 'components/ui/divider/HorizontalDivider';

const OrderSettings = () => {
    const resources = {
        pageTitle: T('orders.order.settings.title'),
        pageSubTitle : T('orders.order.settings.sub.title'),
    };

  return (
    <div className="container">
      <PageHeader title={resources.pageTitle} subTitle={resources.pageSubTitle} />

      <HorizontalDivider spacing="lg" />

      <OrderSettingsForm />
    </div>
  )
}

export default OrderSettings